/*
 * The view for the 'change password' modal
 */

define([
  "marionette",
  "modules/admin/userAdmin/passwordAdmin/template/passwordAdminTemplate.html",
], function (Marionette, PasswordAdminTemplate) {
  var PasswordAdminView = {};

  PasswordAdminView.passwordAdminView = Marionette.ItemView.extend({
    template: PasswordAdminTemplate,
    //clear and hide the errors from the text inputs
    clearErrors: function () {
      this.$el.find(".control-group").removeClass("error");
      this.$el.find(".help-block").addClass("hidden").empty();
    },
    getOldPassword: function () {
      return this.$el.find("#oldPassword").val();
    },
    getNewPassword: function () {
      return this.$el.find("#newPassword").val();
    },
    getReenterPassword: function () {
      return this.$el.find("#reenterPassword").val();
    },
    setOldPasswordError: function (error) {
      this.$el.find("#oldPasswordControl").addClass("error");
      this.$el.find("#oldPasswordError").removeClass("hidden").text(error);
    },
    setNewPasswordError: function (error) {
      this.$el.find("#newPasswordControl").addClass("error");
      this.$el.find("#newPasswordError").removeClass("hidden").text(error);
    },
    setReenterPasswordError: function (error) {
      this.$el.find("#reenterPasswordControl").addClass("error");
      this.$el.find("#reenterPasswordError").removeClass("hidden").text(error);
    },
    triggers: {
      "submit form": "done",
      "click #cancelButton": "cancel",
    },
  });

  return PasswordAdminView;
});
